<template>
  <div :class="wrapperClasses" @click="makeEditable">
    <div class="ui label">{{addressTypeLabel}}</div>
    <address class="street">
      <toggle-edit :value="street" :mayEdit="mayEdit">
        <b-input type="textarea" rows="3" cols="32" v-model="street" />
      </toggle-edit>
    </address>
    <h5 class="locality">
      <toggle-edit :value="locality" :mayEdit="mayEdit">  
          <b-input type="text" v-model="locality" />
      </toggle-edit>
    </h5>
    <p class="postcode">
      <toggle-edit :value="postcode" :mayEdit="mayEdit">
        <b-input type="text" v-model="postcode" maxlength="12" />
      </toggle-edit>
    </p>
    <toggle-edit :value="region" :mayEdit="mayEdit">
      <b-input type="text" v-model="region" maxlength="12" />
    </toggle-edit>
    <p v-if="showCountry" class="country">{{country}}</p>
  </div>
</template>
<script type="text/javascript">
import { bus } from "../main";
import { saveSubmission } from "../api/methods"
import { extractString } from "../api/helpers";
import { addressSchema } from "../store/schemas";
import { submissionSchema } from "../store/submission";
import ToggleEdit from "./ToggleEdit";
import { mapGetters } from "vuex";

export default {
  name: "AddressCard",
  components: {
    ToggleEdit
  },
  props: {
    address: {
      type: Object,
      required: true,
      default: null
    },
    submission: {
      type: Object,
      required: true,
      default: submissionSchema
    },
    type: {
      type: String,
      default: ''
    },
    countries: {
      type: Array,
      required: false,
      default: null
    },
    mayEdit: {
      type: Boolean,
      default: false
    },
    primaryPostal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ...addressSchema,
      editable: false
    };
  },
  computed: {
    ...mapGetters(["settings"]),
    wrapperClasses() {
      let cls = ['address'];
      if (this.type === 'collection') {
        cls.push('collection-address');
      } else {
        cls.push('postal-address');
      }
      return cls;
    },
    addressTypeLabel() {
      const type = this.primaryPostal? this.type : "collection";
      switch (type) {
        case 'collection':
          return "Collection address";
        case 'postal':
          return "Postal address";
        default:
          return "";
      }
    },
    hasRegion() {
      return this.region.length > 1;
    },
    showCountry() {
      return this.settings.show_country_selector;
    },
    country() {
      let cc = this.countryCode;
      if (cc.length < 2) {
        cc = "GB";
      }
      let cName = cc;
      if (this.countries instanceof Array && this.countries.length > 1) {
        const cn = this.countries.find(c => c.id === cc);
        if (cn) {
          cName = cn.label;
        }
      }
      return cName; 
    }
  },
  mounted() {
    this.mapAddress();
    bus.$on('save-details', () => {
      setTimeout(() => {
        this.save();
      }, 750);
    })
  },
  methods: {
    makeEditable() {
      if (this.mayEdit) {
        this.editable = true;
      }
    },
    mapAddress() {
      this.street = extractString(this.address, "street");
      this.locality =  extractString(this.address, "locality");
      this.postcode = extractString(this.address, "postcode");
      this.region = extractString(this.address, "region");
      this.countryCode = extractString(this.address, "countryCode");
    },
    save() {
      const { _id, user } = this.submission;
      if (_id.length > 5 && user instanceof Object) {
        let address = {
          street: this.street,
          locality: this.locality,
          region: this.region,
          postcode: this.postcode
        };
        let edited = { _id, user: user._id };
        switch (this.type) {
          case 'collection':
            edited.collectionAddress = address;
            break;
          default:
            edited.address = address;
            break;
        }
        saveSubmission(edited);
      }
    }
  }
};
</script>